import { Box, Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ListingEntry } from 'graphql/listings/queries';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { NewOrderPartyType } from 'v2-types/order';

import AdditionalFees from './components/additional-fees';
import FormAmounts from './components/form-amounts';
import { DatesAndConfigurationForm, EstateAddress, ParsedAmountEntry } from './services';
import FormClosingDate from './components/form-closing-date';
import FormConfig from './components/form-config';
import FormType from './components/form-type';
import Header from './components/header';
import PlaceOfClosing from './components/place-of-closing';

const useStyles = makeStyles((theme) => ({
  rootContainer: { padding: theme.spacing(2) },
  mainContainer: { padding: theme.spacing(2) },
  columnContainer: {
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
}));

type DatesAndConfigSceneProps = {
  transactionTypes: ListingEntry[];
  workflows: ListingEntry[];
  settelmentStatements: ListingEntry[];
  methods: UseFormReturn<DatesAndConfigurationForm, object>,
  parties: Pick<NewOrderPartyType, 'name' | '_id' | 'accounts' | 'kinds'>[],
  estatesMap: Map<string, EstateAddress>;
  loansMap: Map<string, string>;
  purchasePriceEntries: ParsedAmountEntry[];
  loanAmountEntries: ParsedAmountEntry[];
};

const DatesAndConfigScene = ({
  transactionTypes,
  workflows,
  settelmentStatements,
  methods,
  parties,
  estatesMap,
  loansMap,
  purchasePriceEntries,
  loanAmountEntries,
}: DatesAndConfigSceneProps) => {
  const classes = useStyles();
  return (
    <>
      <FormProvider {...methods}>
        <Box className={classes.rootContainer}>
          <Paper>
            <Grid container direction="column" wrap="nowrap">
              <Grid item xs={12}>
                <Header />
              </Grid>
              <Grid item xs={12} className={classes.mainContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={4} className={classes.columnContainer}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormType
                          transactionTypes={transactionTypes}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <FormClosingDate />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4} className={classes.columnContainer}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <PlaceOfClosing parties={parties} />
                      </Grid>
                      <Grid item xs={12}>
                        <AdditionalFees />
                      </Grid>
                      <Grid item xs={12}>
                        <FormConfig
                          workflows={workflows}
                          settelmentStatements={settelmentStatements}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={4} className={classes.columnContainer}>
                    <Grid container direction="column" wrap="nowrap" spacing={2}>
                      <FormAmounts
                        estatesMap={estatesMap}
                        loansMap={loansMap}
                        purchasePriceEntries={purchasePriceEntries}
                        loanAmountEntries={loanAmountEntries}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </FormProvider>

    </>
  );
};

export default DatesAndConfigScene;
